import { render, staticRenderFns } from "./AboutUSBannerDetail.vue?vue&type=template&id=b59fb202&scoped=true"
import script from "./AboutUSBannerDetail.vue?vue&type=script&lang=js"
export * from "./AboutUSBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./AboutUSBannerDetail.vue?vue&type=style&index=0&id=b59fb202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59fb202",
  null
  
)

export default component.exports